import Image from 'next/image';
import React from 'react'
import { BASE_URL } from '../../utils/FetchData';

export const MasterplanSubCard = ({
    // setActivePhase,
    setShowData,
    activePhase,
    index,
    phase
}) => {
    return (
        <div
            className={`project ${activePhase == index ? "active" : ""
                }`}
            onClick={() => {
                // setActivePhase(index);
                setShowData(true)
            }}
        >
            <div className="image-container">
                {phase &&
                    <Image
                        src={BASE_URL + phase?.attributes?.Master_Plan_Card?.Thumbnails_Desktop?.data?.attributes?.url}
                        alt={phase?.attributes?.Master_Plan_Card?.Thumbnails_Desktop?.data?.attributes?.name}
                        objectFit="cover"
                        layout="fill"
                    />
                }
            </div>
            <div className="title bold">
                <h4>{phase?.attributes?.Master_Plan_Card?.Phase_Name}</h4>
            </div>
        </div>
    )
}
